import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Close } from '@material-ui/icons';
import {
  TextField,
  CircularProgress,
  Drawer,
  IconButton,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import TargetedAudience from '../../Sendmessage/Audience/Components/Footer/TargetedAudience';
import { selectedOrganizationSelector } from '../../../redux/selector';
import { formatPhoneNumber } from '../utils';
import {
  Wrapper,
  Wrap,
  Center,
  EventIdMessageWrapper,
} from './MessageDetails.styled';
import ABmessageDetails from './ABmessageDetails';
import SingleMessageDetails from './SingleMessageDetails';
import Feature from '../../../infrastructure/features';
import { useIsFeatureEnabled } from '../../../libs/feature-toggles/react';
import EventIdMessageUpdateSelector from '../EventIdMessageUpdateSelector';
import { Header, Container } from './MessageDetailsDrawer.styled';

const statusToColor = {
  Sent: '#5eab00',
  Scheduled: '#f86f00',
  Cancelled: '#ff6161',
};

const useStyles = makeStyles(() => ({
  textField: {
    '& input:disabled': {
      color: '#212121',
    },
  },
}));

const MessageDetailsDrawer = ({
  message,
  isSuperUser,
  topics,
  groups,
  isLoading,
  isDrawerVisible,
  closeDrawer,
}) => {
  const organization = useSelector(selectedOrganizationSelector);
  const classes = useStyles();
  const phoneNumber = formatPhoneNumber(organization.fromPhone);
  const [eventId, setEventId] = useState(null);

  const eventIdSelectionRef = useRef();
  const isEventsAndClassesFeatureEnabled = useIsFeatureEnabled(
    Feature.EVENTS_AND_CLASSES
  );
  const isABmessage = message && message.AB && message.AB.linkedMessageId;

  useEffect(() => {
    setEventId(message?.eventId);
  }, [message?.eventId]);

  const getContent = () => {
    if (isLoading) {
      return (
        <Center>
          <CircularProgress
            style={{ margin: 'auto', alignItems: 'center', color: '#007ADE' }}
          />
        </Center>
      );
    }
  };

  return (
    <Drawer open={isDrawerVisible} onClose={closeDrawer} anchor="right">
      <Header>
        <IconButton size={'small'} style={{ color: 'white' }}>
          <Close size={'small'} onClick={closeDrawer} />
        </IconButton>
        Message Details
      </Header>
      <Container>
        {isLoading ? (
          getContent()
        ) : (
          <Wrapper>
            <TextField
              className={classes.textField}
              disabled
              label="Message"
              variant="outlined"
              size="small"
              value={message.draftName || 'N/A'}
            />
            <Wrap>
              <TextField
                className={classes.textField}
                disabled
                label="Status"
                variant="outlined"
                size="small"
                value={message.status || 'N/A'}
                inputProps={{
                  style: { color: statusToColor[message.status] },
                }}
                style={{
                  width: '50%',
                }}
              />
              <TextField
                className={classes.textField}
                disabled
                label="Send Date"
                variant="outlined"
                size="small"
                value={
                  moment.unix(message.sendTime).format('MMMM Do, YYYY') || 'N/A'
                }
                style={{ width: '50%' }}
              />
            </Wrap>
            {isEventsAndClassesFeatureEnabled && (
              <EventIdMessageWrapper>
                <EventIdMessageUpdateSelector
                  isEventIdRequired={true}
                  eventIdSelectionRef={eventIdSelectionRef}
                  eventId={eventId}
                  setEventId={setEventId}
                  message={message}
                />
              </EventIdMessageWrapper>
            )}
            {isABmessage ? (
              <ABmessageDetails
                classes={classes}
                phoneNumber={phoneNumber}
                message={message}
                isSuperUser={isSuperUser}
              />
            ) : (
              <SingleMessageDetails
                classes={classes}
                phoneNumber={phoneNumber}
                message={message}
                isSuperUser={isSuperUser}
              />
            )}
            <TargetedAudience
              message={message}
              topics={topics}
              groups={groups}
            />
          </Wrapper>
        )}
      </Container>
    </Drawer>
  );
};

export default MessageDetailsDrawer;
